import {
  EnvironmentConfig,
  environmentDefaults,
  featureFlagDefaults,
  oidcDefault,
} from '@cigna/chcp/shared/environment-util';

export const environment: EnvironmentConfig = {
  ...environmentDefaults,
  oidc: {
    ...oidcDefault,
    secureUris: ['https://p-chcp.digitaledge.cigna.com', '/prv/secure'],
  },
  api: {
    proxy: {
      headers: {
        accept: '*/*',
        content_type: 'application/json',
      },
    },
    gateways: {
      cdn: 'https://static.cigna.com/',
      secureApi: 'https://p-chcp.digitaledge.cigna.com/chcp',
      publicApi: 'https://p-chcp.digitaledge.cigna.com/public',
      gsgPublicApi: 'https://p-gsg.digitaledge.cigna.com/public',
      gsgSecureApi: 'https://p-gsg.digitaledge.cigna.com',
    },
    searchIndex: 'prod',
    salesDemo: false,
  },
  trustId: '5045161',
  features: {
    ...featureFlagDefaults,
    nextRelease: false,
    patientEnhBehaviorStandalone: false,
    patientEnhPower: false,
    patientEnhDentalAmInNet: false,
    claimsMcNotification: false,
    messageCenterPreference: false,
    messageCenterPrefWAM: false,
    precertManual: false,
    emailVerifyPopup: false,
    allowMfaSetting: false,
    claim360SearchClaim: false,
    claim360SearchOffice: false,
    claim360SearchProvider: false,
    claim360Download: false,
    claim360Help: false,
    csnBenefits: false,
    csnCPT: false,
    newFeaturesBanner: false,
  },
};
